import * as React from 'react';
import { SVGProps } from 'react';
export const RewardsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    viewBox="0 0 14 14"
    fill="none"
    {...props}
  >
    <path
      fill="#6E7384"
      d="M11.938.25H2.062A1.312 1.312 0 0 0 .75 1.563v3.075a1.312 1.312 0 0 0 .77 1.194l3.5 1.592a3.25 3.25 0 1 0 3.957 0l3.5-1.592a1.313 1.313 0 0 0 .773-1.194V1.563A1.313 1.313 0 0 0 11.937.25ZM7 6.676l-1.75-.795V1.75h3.5v4.13L7 6.677ZM2.25 1.75h1.5v3.449l-1.5-.682V1.75Zm4.75 10a1.75 1.75 0 1 1 0-3.5 1.75 1.75 0 0 1 0 3.5Zm4.75-7.233-1.5.682V1.75h1.5v2.767Z"
    />
  </svg>
);
